import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { forwardRef } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material";

const Page = forwardRef(({ children, title = "", ...other }, ref) => {
  const theme = useTheme();
  return (
    <Box
      ref={ref}
      sx={{
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.background.default
            : theme.palette.primary.light,
        minHeight: "100vh",
        height: '100%'
      }}
      {...other}
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </Box>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Page;
